module.exports = "pegasus/assets/themelp1/travel/108.png";